
import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import AppUniversal from './app-universal.jsx';
import { ScrollToTop } from '../../components';

const App = (
  <BrowserRouter>
    <ScrollToTop>
      <AppUniversal />
    </ScrollToTop>
  </BrowserRouter>
);


export default App;



// WEBPACK FOOTER //
// ./client/pages/main/app.jsx